import { render } from "./DetailsForm.vue?vue&type=template&id=4f576100&scoped=true"
import script from "./DetailsForm.vue?vue&type=script&lang=js"
export * from "./DetailsForm.vue?vue&type=script&lang=js"

import "./DetailsForm.vue?vue&type=style&index=0&id=4f576100&scoped=true&lang=scss"
import "../assets/css/client.css?vue&type=style&index=1&id=4f576100&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f576100"]])

export default __exports__